import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API, withCredentials: true });

const NO_RETRY = ["/auth/refresh", "/auth/login", "/auth/register", "/auth/google/session"];
let refreshing = null;

export async function refreshSession() {
  refreshing = refreshing || api.post("/auth/refresh").finally(() => { refreshing = null; });
  return refreshing;
}

api.interceptors.response.use(
  (r) => r,
  async (err) => {
    const cfg = err.config;
    if (err.response?.status === 401 && cfg && !cfg._retry && !NO_RETRY.some((u) => cfg.url?.includes(u))) {
      cfg._retry = true;
      try {
        await refreshSession();
        return api(cfg);
      } catch (_) { /* fallthrough */ }
    }
    return Promise.reject(err);
  }
);

export const fileUrl = (p) => (p ? `${API}/files/${p}` : null);
export const outUrl = (id) => `${API}/out/${id}`;
export const itemImage = (it) => (it?.image_path ? fileUrl(it.image_path) : it?.image_url);

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || "Etwas ist schiefgelaufen. Bitte erneut versuchen.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return d.msg || String(d);
}

export const CATEGORIES = ["Oberteil", "Hose", "Kleid", "Jacke", "Schuhe", "Accessoire"];
export const eur = (n) => new Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR" }).format(n || 0);

export async function uploadImage(file) {
  const fd = new FormData();
  fd.append("file", file);
  const { data } = await api.post("/upload", fd);
  return data.path;
}
